import React from 'react';
import { translate as t } from 'utils/i18n';
import BaseNewsDisplay from 'components/news/BaseNewsDisplay';
import {
  NewsCardList,
  NewsCard,
  NewsCardThumbnail,
  NewsCardThumbnailPlaceholder,
  NewsCardBody,
  NewsCardTitle,
  NewsCardDate,
  NewsCardDescription,
  NewsSingleText,
} from '../styles';

class WarwickNewsDisplay extends BaseNewsDisplay {
  render() {
    const { feedItems, loading } = this.state;
    const description = this.props.news['locale_latest_news']?.locale_description;

    if (loading) {
      return (
        <NewsCardList ref={this.scrollRef}>
          <NewsSingleText>{t('errors.loadingMessage')}</NewsSingleText>
        </NewsCardList>
      );
    }

    if (feedItems.length > 0) {
      const hasThumbnails = feedItems.some((item) => item.thumbnail);

      return (
        <NewsCardList ref={this.scrollRef}>
          {feedItems.map((item, index) => (
            <NewsCard key={index}>
              {hasThumbnails &&
                (item.thumbnail ? (
                  <NewsCardThumbnail src={item.thumbnail} alt={item.title} />
                ) : (
                  <NewsCardThumbnailPlaceholder />
                ))}
              <NewsCardBody>
                <NewsCardTitle>{item.title}</NewsCardTitle>
                {item.pubDate && (
                  <NewsCardDate>{new Date(item.pubDate).toLocaleString()}</NewsCardDate>
                )}
                {item.description && <NewsCardDescription>{item.description}</NewsCardDescription>}
              </NewsCardBody>
            </NewsCard>
          ))}
        </NewsCardList>
      );
    }

    // Single-news fallback: plain text, no image / timestamp / description
    if (description) {
      return (
        <NewsCardList ref={this.scrollRef}>
          <NewsSingleText>{description}</NewsSingleText>
        </NewsCardList>
      );
    }

    return (
      <NewsCardList ref={this.scrollRef}>
        <NewsSingleText>{'No news feed configured.'}</NewsSingleText>
      </NewsCardList>
    );
  }
}

export default WarwickNewsDisplay;
